module.exports = __webpack_public_path__ + "media/images/icon__predict@3x-1082c985f586d7d100ccff8213d9e9d6.png";